import type { AmplitudeEventProps } from '@brighterly/lib-core-functions/analytics'

import { trackEvent } from '@shared/lib/amplitude'

export const useModalTracking = (show: ComputedRef<boolean>, getEventProps: () => AmplitudeEventProps): void => {
  const track = (): void => {
    if (show.value) {
      trackEvent('Popup_view', getEventProps())
    }
  }

  onMounted(track)
  watch(show, track)
}
